import { IWalletBallance } from 'types/wallet'
import { ICaloWalletBallance } from './types'

export const convertStructureWallet = (
  old: ICaloWalletBallance,
): IWalletBallance => {
  return { fitBalance: +old.fitAmount, caloBalance: +old.caloAmount }
}
